// exports.host     = 'http://192.168.1.128:7258/api/v1';
// exports.ws       = 'ws://192.168.1.128:7258/api/v1';

exports.host     = 'http://api.avails.ru/api/v1';
exports.ws       = 'ws://api.avails.ru/api/v1';

exports.BaseAddress = 'http://avails.ru';

// API Routes
//
exports.IdentityServiceApi = `${exports.host}/Identity`;
exports.UserServiceApi = `${exports.host}/Users`;
exports.TagsServiceApi = `${exports.host}/Tags`;
exports.CalendarServiceApi = `${exports.host}/Calendar`;
exports.UserTagsServiceApi = `${exports.host}/UserTags`;
exports.AvatarsServiceApi = `${exports.host}/Avatars`;

// exports.SettingServiceApi = `${exports.host}/Settings`;


// SignalR channels
//
exports.DashboardEvents = 'dashboard-events';

// TEXT
//
exports.ServerNotRunningText = 'НЕТ СОЕДИНЕНИЯ ПО WEBSOCKET';
exports.apptitle = "Avails";
exports.appsubtitle = "соцсеть, которая не «затягивает»,\nа «возвращает» в реальный мир\nи живое общение";
exports.appFooterText = exports.apptitle + " — соцсеть не для «залипания», бесконечного скроллинга, расшатывания психики и «убийства времени», а удобная платформа для организации и планирования активной офлайн-жизни.";